export default function Django_Quiz() {
  return <div>Django_Quiz Component</div>;
}
